import SelectUiDialog from '@/pages/MainPage/dialogs/SelectUiDialogNew'
import InputModalSelect from '../components/InputModalSelect.jsx'

export default function SelectUi({value, ...props}) {
    const getText = multiple => multiple ?
        (value ?? []).map(({uiName}) => uiName).join(',') :
        (value ?? {}).uiName

    return (
        <InputModalSelect
            getText={getText}
            Modal={SelectUiDialog}
            {...props}
        />
    )
}
